import React, { Component } from 'react';
import { map } from 'lodash';
import './style.scss';
import { Favorite, Room } from '@material-ui/icons';
import { Link } from 'react-router-dom';
export default class BorrowerItem extends Component {
    addToFavorites(e) {
        e.preventDefault();
    }

    render() {
        return (
            <div className='borrower-item'>
                <div className="borrower-image" style={{ background: `#ccc url('${this.props.borrower.picture}') no-repeat center`, backgroundSize: 'cover' }} />
                <div className='name'>{this.props.borrower.name}</div>
                <div className='role'>Pet Borrower</div>
                <div className='location'>
                    <div><Room /> {this.props.borrower.location}</div> <button className='favorite' onClick={this.addToFavorites.bind(this)}><Favorite /></button>
                </div>
                <div className='description'>{this.props.borrower.description}</div>
                <div className='availability'>
                    <label> Available on:</label>
                    {
                        map(this.props.borrower.availablity, availabity => (
                            <span className='borrower-availabity' key={availabity}>{availabity}</span>
                        ))
                    }
                </div>
                <div className='contact-button'>
                    <Link to={{ pathname: '/borrower-info', state: { borrower: this.props.borrower } }} className="link-button" >Learn more about {this.props.borrower.name}</Link>
                    
                </div>
            </div>
        );
    }
}
